import { Component, inject, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AvatarComponent } from '../../avatar.component';
import { cn } from '../../../../lib/utils';

@Component({
  selector: 'app-avatar-fallback',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './avatar-fallback.component.html',
})
export class AvatarFallbackComponent {
  protected avatar = inject(AvatarComponent);
  @Input() className: string = '';

  get classes() {
    return cn(
      'flex h-full w-full items-center justify-center rounded-full bg-muted',
      this.className,
    );
  }
}
